import type { HttpClient } from '@/infrastructure/http/HttpClient'
import type { UserRepository } from '@/domain/user/UserRepository'
import type { User } from '@/domain/user/User'
import { RateLimitError } from '@/domain/auth/errors'

function isHttpStatus(e: unknown, status: number): boolean {
  return (e as { response?: { status?: number } })?.response?.status === status
}

export class HttpUserRepository implements UserRepository {
  constructor(private http: HttpClient) {}

  async getCurrentUser(): Promise<User> {
    return this.http.url('backoffice/assert').get<User>()
  }

  async listSocietyUsers(opts: { ownSociety?: boolean } = {}): Promise<User[]> {
    const params: Record<string, string> = { page_size: '-1' }
    if (opts.ownSociety) params.own_society = 'true'
    const response = await this.http.url('users/options').params(params).get<{ results: User[] }>()
    return response.results
  }

  // why: `users/options` leaves the email out on purpose; the admin list has it, behind the same config permission.
  async listSocietyUsersWithEmail(): Promise<User[]> {
    const response = await this.http.url('users').params({ page_size: '-1', sort_by: 'name', sort_order: 'asc' }).get<{ results: User[] }>()
    return response.results
  }

  // `users/0/` answers with the caller; `backoffice/assert` would too, but only for staff.
  async getSelf(): Promise<User> {
    const response = await this.http.url('users/0').get<{ user: User }>()
    return response.user
  }

  async requestPasswordReset(email: string): Promise<void> {
    try {
      await this.http.url('users/reset_password').body({ email }).post()
    } catch (e) {
      if (isHttpStatus(e, 429)) throw new RateLimitError()
      throw e
    }
  }
}
